import { Row } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { Board } from '../../components/Board';
import { ExtraLives } from './components/ExtraLives';
import { GameOver } from './components/GameOver';
import { GhostsGameView } from './components/GhostsView';
import { MazeView } from './components/MazeView';
import { PacManView } from './components/PacManView';
import { PillsView } from './components/PillsView';
import { Score } from './components/Score';
import { useStore } from '../../components/StoreContext';
import { useKeyboardActions } from './components/useKeyboardActions';
import { VSpace } from '../../components/Spacer';
import { useGameLoop } from '../../model/useGameLoop';
import dpad from '../../resources/pad.png';
import sprite from '../../resources/arcade_pacman_sprites.png';
import loading from "../../resources/heart-chase.png"

export const GamePage: React.FC = observer(() => {
  const store = useStore();
  const pacMan = store.game.pacMan;
  useEffect(() => {
    store.resetGame();
    store.game.gamePaused = true;
    return () => {
      store.game.gamePaused = true;
    };
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, []);

  const startGame = () => {
    store.game.gamePaused = false;
  }
  
  const resetGame = () => {
    store.resetGame();
    store.game.gamePaused = true;
  }

  useGameLoop();
  useKeyboardActions();

  return (
    <Layout data-testid="GamePage">
     
      <ScoreArea>
        <Row justify="center">
          <Score />
        </Row>
        <VSpace size="small" />
      </ScoreArea>

      <EmptyArea />

      <BoardArea style={{position: "relative"}}>
        
        <img onClick={startGame} src={loading} alt="loading" style={{margin: "0 auto", width: "98%", position: "absolute", top:0, left:0, zIndex: 1000, opacity: store.game.gamePaused ? 1 : 0, transition: "opacity 0.3s ease-in-out"}} />
        <div style={{opacity: store.game.gamePaused ? 0 : 1, transition: "opacity 0.3s ease-in-out"}}>
        <Board>
          <MazeView />
          <PillsView />
          <PacManView />
          <GhostsGameView />
          <GameOver />
        </Board>
        <VSpace size="small" />
        <Row justify="center">
          <div style={{border: "3px solid blue", borderRadius: "10px", padding: "4px 8px 0px", fontFamily: "Joystix", display: "flex", alignItems: "center", gap: "8px", justifyContent:"center", marginBottom: "16px"}}>
            <p style={{marginBottom: 0}}>Lives</p>
            <ExtraLives />
          </div>
        </Row>
        <Row justify='space-between' style={{position: "relative", zIndex: 1000, marginRight: "10px"}}>
          {/* Dpad */}
          <div style={{ position: 'relative' }}>
            <button style={{ opacity: 0,background: "none", border: "none", position: 'absolute', top:0, left:"50%", transform: 'translateX(-50%)', width: '70px', height: '70px' }} onClick={() => pacMan.nextDirection = 'UP'}>up</button>
            <button style={{ opacity: 0,background: "none", border: "none", position: 'absolute', top:"100%", left:"50%", transform: 'translateY(-100%) translateX(-50%)', width: '70px', height: '70px' }} onClick={() => pacMan.nextDirection = 'DOWN'}>down</button>
            <button style={{ opacity: 0,background: "none", border: "none", position: 'absolute', top:"50%", left:0, transform: 'translateY(-50%)', width: '70px', height: '70px' }} onClick={() => pacMan.nextDirection = 'LEFT'}>left</button>
            <button style={{ opacity: 0,background: "none", border: "none", position: 'absolute', top:"50%", left:"50%", transform: 'translateY(-50%) translateX(50%)', width: '70px', height: '70px' }} onClick={() => pacMan.nextDirection = 'RIGHT'}>right</button>
            <img src={dpad} alt="dpad" />
          </div>
          <div style={{ position: 'relative', display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px"}}>
            {/* <button onClick={startGame} style={{ borderRadius: "6px", color: "black", padding: "10px 20px", fontSize: "1rem", textTransform: "uppercase", fontFamily: "Joystix"}}>Start</button> */}
            <button onClick={resetGame} style={{ borderRadius: "6px", color: "black", padding: "10px 20px", fontSize: "1rem", textTransform: "uppercase", fontFamily: "Joystix"}}>Reset</button>
          </div>
          {/* Legend */}
          <div style={{ position: 'relative', display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "center", gap: "10px", fontFamily: "Joystix"}}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ backgroundImage: `url(${sprite})`, backgroundPosition: '-457px -65px', width: '15px', height: '15px', transform: 'scale(2.25)' }} />
              <h2 style={{color: "#f1c484", fontSize:"1rem", marginBottom:"4px"}}>LP(A)</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ backgroundImage: `url(${sprite})`, backgroundPosition: '-457px -82px', width: '15px', height: '15px', transform: 'scale(2.25)' }} />
              <h2 style={{color: "#406eb5", fontSize:"1rem", marginBottom:"4px"}}>APO B</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ backgroundImage: `url(${sprite})`, backgroundPosition: '-457px -98px', width: '15px', height: '15px', transform: 'scale(2.25)' }} />
              <h2 style={{color: "#f83d4b", fontSize:"1rem", marginBottom:"4px"}}>NON HDL</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ backgroundImage: `url(${sprite})`, backgroundPosition: '-457px -113px', width: '15px', height: '15px', transform: 'scale(2.25)' }} />
              <h2 style={{color: "#e9c427", fontSize:"1rem", marginBottom:"4px"}}>TRIGLYCERIDE</h2>
            </div>
            
          </div>
        </Row>
</div>
      </BoardArea>

   
    </Layout>
  );
});

const Layout = styled.div`
  margin-left: 16px;
  margin-right: 16px;

  display: grid;

  @media (min-width: 1280px) {
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }
  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
    
    justify-items: center;
  }
`;

const ScoreArea = styled.div``;

const EmptyArea = styled.div``;

const BoardArea = styled.div``;


